<template>
  <div
    class="freestyle-audio-toggle-container"
    :class="{'is-not-presenting': !isPresenting}"
    v-show="audioAvailable"
  >
    <div
      class="freestyle-audio-toggle __wrapper"
      :class="{'light-text': isTextColourLight,
               'is-first-icon': hasClassIsFirstIcon}"
    >
      <aha-icon
        name="music-note"
        class="freestyle-audio-toggle __music-note"
      />
      <div class="freestyle-audio-toggle __audio">
        <AudioControl v-if="hasSlideMusic" />
        <BackgroundMusic v-show="showBackgroundMusic" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AudioControl from '@/components/presentations/AudioControl.vue'
import BackgroundMusic from '@/components-v2/presentation-editor/middle/BackgroundMusic.vue'
import QuizStatuses from '@/constant/QuizStatuses'
import Constant from '@/constant'

const noAudioTypes = new Set(Constant.slideTypesNoAudio)

export default {
  components: {
    AudioControl,
    BackgroundMusic,
  },
  computed: {
    ...mapGetters(['isPresenting', 'isTextColourLight']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
      presentation: (state) => state.presentation,
    }),
    hasClassIsFirstIcon() {
      return !this.isPresenting || this.sharePresentation
    },
    isQuizLobbyScreen() {
      const { type, quizStatus } = this.slideActive
      return type === 'pickAnswer' && quizStatus === QuizStatuses.LOBBY_SCREEN
    },
    isSpinnerWheelSlide() {
      return this.slideActive.id && this.slideActive.type === 'spinnerWheel'
    },
    isDisableAudio() {
      if (!this.showingAudioTab) return false
      return true
    },
    audioAvailable() {
      // return this.slideActive.id && this.slideActive.audioLink && !this.isQuizLobbyScreen
      return !this.isSpinnerWheelSlide && (this.hasBackgroundMusic || this.hasSlideMusic)
    },
    hasSlideMusic() {
      return !this.isQuizLobbyScreen && this.slideActive.id && this.slideActive.audioLink
    },
    hasBackgroundMusic() {
      return this.presentation.audioLink
    },
    showBackgroundMusic() {
      return this.hasBackgroundMusic && !this.hasSlideMusic
    },
    showingAudioTab() {
      return this.$store.getters.selectedSlides.some(
        (s) => s.id && !noAudioTypes.has(s.type),
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.freestyle-audio-toggle-container {
  opacity: 0;
  font-size: 1.4rem;
  z-index: 126;
  transition: all 0.3s ease;
  &.is-not-presenting {
    opacity: 1;
  }
}
.freestyle-audio-toggle {
  position: absolute;
  cursor: pointer;
  top: 0.5rem;
  left: 4.25rem;
  transition: all 0.3s ease;
    &.is-first-icon {
    left: 1rem;
  }
  &.__wrapper {
    @apply rounded-full w-10 h-10 bg-base-30 hover:bg-base-40;

    &.light-text {
      background-color: rgba(0, 0, 0, 0.36);
    }
    &:hover.light-text {
      background-color: rgba(0, 0, 0, 0.5);
    }
    &:hover {
      .__audio {
        @apply opacity-100 pointer-events-auto;
      }
    }
  }
  &.__audio {
    @apply absolute opacity-0 top-6 -left-1 pointer-events-none pt-6;
  }
  &.__music-note {
    @apply text-xl absolute top-2 left-2;
  }
}
</style>
